export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Footer.vue?vue&type=template&id=6126d139&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.vue?vue&type=template&id=6126d139&
// module id = 911
// module chunks = 0